import {
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    FolderOpen as FolderOpenIcon,
    PostAdd as PostAddIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    AppBar,
    Box,
    Button,
    CardContent,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    InputAdornment,
    InputLabel,
    Paper,
    Select,
    Switch,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    appendFieldsToFormData,
    formatData,
    getCurrencyInputValue,
    getCodUsuarioRegistrou,
    getDateInputValue,
    getInputValue,
    getOnlyDigits,
    parseCurrencyInputValue,
    validateField
} from 'lib/functions';
import {
    ANAO,
    AREGIME_TRABALHO_MISTO,
    AREGIME_TRABALHO_NENHUM,
    AREGIME_TRABALHO_RODOVIARIO,
    AREGIME_TRABALHO_SEVERO,
    ASIM
} from '../../../consts';
import PropTypes from 'prop-types';
import api from '../../../services/api';
import React, { Component } from 'react';
import { validateComboFields } from 'lib/configUtils';
import ComboPadrao from 'views/Components/ComboPadrao';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';

function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
};

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

class VeiculoForm extends Component {
    state = {
        openModalOpcionais: false,
        arquivoDocTS: null,
        arquivoDocRedeInterna: null,
        arquivoTS: null,
        arquivoRedeInterna: null,
        openConfirmRemoveSeguroTS: false,
        openConfirmRemoveSeguroRedeInterna: false,
        openConfirmRemoveDocumentoTS: false,
        openConfirmRemoveDocumentoRedeInterna: false,
        isNewRecord: false,
        isView: false,
        openModalOne: false,
        openModalTwo: false,
        openConfirmDeleteOpcional: false,
        opcionalASerExcluido: null,
        opcionalDescASerExcluido: '',
        openConfirmDeleteDocumento: false,
        documentoASerExcluido: null,
        documentoChaveASerExcluida: '',
        documentoDescASerExcluido: '',
        openModalDocumentos: false,
        documentoSelecionado: null,
        openConfirmRemoveOpcional: false,
        opcionalASerRemovido: null,
        opcionalDescASerRemovido: '',
        activeTab: 0,
        documentosDisponiveis: [],
        documentosveiculo: [],
        eixos: [],
        tiposveiculo: [],
        combustiveis: [],
        modelosveiculo: [],
        fornecedores: [],
        projetos: [],
        opcionais: [],
        opcionaisveiculo: [],
        motoristas: [],
        fornecedorestransp: [],
        fornecedoresgeral: [],
        nomeMarcaAssociada: '',
        errors: {},
        documento: {
            descricao: '',
            vencimento: '',
            localdocts: '',
            localdocredeint: '',
            avisodiasantecedencia: '',
            descritivodoc: '',
            inativodoc: ANAO
        },
        veiculo: {
            codveiculo: '',
            nroveiculo: '',
            codtipoveiculo: '',
            codmodeloveiculo: '',
            descritivo: '',
            obsseguro: '',
            localdocsegts: '',
            localdocsegredeint: '',
            kmatual: '',
            inativo: ANAO
        },
        opcional: {
            codopcionalveiculo: 0,
            descopcionalveiculo: '',
            inativoopc: ANAO
        },
        schemaVeiculo: {
            nroveiculo: {
                presence: { allowEmpty: false, message: 'Número do veículo obrigatório' },
                length: { maximum: 64 },
                type: 'string'
            },
            codtipoveiculo: {
                presence: { allowEmpty: false, message: 'Tipo de veículo obrigatório' },
                length: { maximum: 64 },
                type: 'integer'
            },
            codfornecedorveiculo: {
                presence: { allowEmpty: false, message: 'Fornecedor do veículo obrigatório' },
                length: { maximum: 64 },
                type: 'integer'
            }
        },
        schemaDocumento: {
            descricao: {
                presence: { allowEmpty: false, message: 'Descrição do documento obrigatória' },
                length: { maximum: 64 },
                type: 'string'
            }
        },
        schemaOpcional: {
            descopcionalveiculo: {
                presence: { allowEmpty: false, message: 'Descrição do opcional obrigatória' },
                length: { maximum: 64 },
                type: 'string'
            }
        }
    };

    estilo = {
        iconGroup: {
            display: 'inline-flex',
            gap: 5
        },
        actionIcon: {
            fontSize: 24,
            color: '#3f51b5',
            cursor: 'pointer'
        }
    };

    /* Altera a cor do ícone ao passar o cursor */
    handleIconMouseEnter = (event) => {
        event.currentTarget.style.color = '#2979ff';
    };

    /* Retorna à cor padrão do ícone ao remover o cursor */
    handleIconMouseLeave = (event) => {
        event.currentTarget.style.color = '#3f51b5';
    };

    /* Altera a cor do ícone de exclusão ao passar o cursor */
    handleDeleteIconMouseEnter = (event) => {
        event.currentTarget.style.color = 'red';
    };

    /* Altera a cor do ícone de folder ao passar o cursor */
    handleUploadIconMouseEnter = (event, isDisabled) => {
        if (isDisabled) return;

        this.handleIconMouseEnter(event);
    };

    /* Retorna à cor padrão do ícone de folder ao remover o cursor */
    handleUploadIconMouseLeave = (event, isDisabled) => {
        if (isDisabled) return;

        this.handleIconMouseLeave(event);
    };

    /* Altera a cor do ícone de remoção de file ao passar o cursor */
    handleRemoveFileIconMouseEnter = (event, isDisabled) => {
        if (isDisabled) return;

        this.handleDeleteIconMouseEnter(event);
    };

    /* Retorna à cor padrão do ícone de remoção de file ao remover o cursor */
    handleRemoveFileIconMouseLeave = (event, isDisabled) => {
        if (isDisabled) return;

        this.handleIconMouseLeave(event);
    };

    /* Inserção de files */
    inputFileTSRef = React.createRef();
    inputFileRedeInternaRef = React.createRef();

    /* Ordena os opcionais pela descrição */
    ordenarOpcionaisVeiculo = (lista = []) => {
        return [...lista].sort((a, b) => String(a.descopcionalveiculo || '').localeCompare(
            String(b.descopcionalveiculo || ''), 'pt-BR', { sensitivity: 'base' }
        ));
    };

    /* Lista os opcionais já vinculados ao veículo */
    listaOpcionais = async (codveiculo) => {
        if (!codveiculo) return;

        try {
            const response = await api.get(`/opcionaisdoveiculo/${codveiculo}`);

            this.setState({
                opcionaisveiculo: this.ordenarOpcionaisVeiculo(
                    Array.isArray(response.data) ? response.data.map(opcional => ({
                        ...opcional,
                        inativoopc: opcional.inativoopc ?? opcional.inativo ?? ANAO
                    })) : []
                )
            });
        } catch (error) {
            console.error('Erro ao buscar opcionais do veículo:', error);

            this.handleOpenAlert('Erro ao listar opcionais do veículo!');
        }
    };

    /* Lista os documentos na grid */
    listaDocumentos = async (codveiculoParam) => {
        const { veiculo } = this.state;
        const codveiculo = codveiculoParam || veiculo.codveiculo;

        if (!codveiculo) return;

        try {
            const response = await api.get(`/docveiculo?codveiculo=${codveiculo}`);

            this.setState({
                documentosveiculo: Array.isArray(response.data?.data) ? response.data.data : []
            });
        } catch (error) {
            console.error('Erro ao buscar documentos do veículo:', error);

            this.handleOpenAlert('Erro ao listar documentos do veículo!');
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { codveiculo, id } = this.props.match.params;
        const routeId = id || codveiculo;
        const { location } = this.props;
        const { veiculo } = this.state;
        const currentPath = location.pathname;

        if (routeId && routeId !== 'novo') {
            try {
                const response = await api.get(`/veiculo/${routeId}`);
                const dados = (
                    response.data && response.data.data && response.data.data[0]
                ) ? response.data.data[0] : {};

                if (!dados || Object.keys(dados).length === 0) {
                    this.handleOpenAlert('Veículo não encontrado!');
                }

                if (dados && dados.kmatual === undefined) {
                    dados.kmatual = null;
                }

                this.setState({
                    veiculo: {
                        ...dados,
                        descritivo: dados.descritivo || '',
                        obsseguro: dados.obsseguro || '',
                        flex: dados.flex || ANAO,
                        codtipoveiculo: dados.codtipoveiculo ? String(dados.codtipoveiculo) : '',
                        codcombustivel: dados.codcombustivel ? String(dados.codcombustivel) : '',
                        codcombustivel2: dados.codcombustivel2 ? String(dados.codcombustivel2) : '',
                        codmodeloveiculo: dados.codmodeloveiculo ? String(dados.codmodeloveiculo) : '',
                        codfornecedorveiculo: dados.codfornecedorveiculo ? String(dados.codfornecedorveiculo) : '',
                        codprojeto: dados.codprojeto ? String(dados.codprojeto) : '',
                        codfornecaquisicao: dados.codfornecaquisicao ? String(dados.codfornecaquisicao) : '',
                        codmotorista: dados.codmotorista ? String(dados.codmotorista) : ''
                    },
                    regimetrabalho: dados.regimetrabalho
                        ? String(dados.regimetrabalho)
                        : String(AREGIME_TRABALHO_NENHUM),
                    descritivo: dados.descritivo || '',
                    obsseguro: dados.obsseguro || '',
                    isNewRecord: false,
                    isView: (currentPath.includes('/view'))
                });

                let paramsmotorista = `?page=1&limit=500&funcionario=S`;
                let paramsfornecedorestransp = `?page=1&limit=500&transportadora=S`;

                const [
                    motoristasResp,
                    fornecedorestranspResp,
                    fornecedoresgeralResp,
                    tiposveiculoResp,
                    combustiveisResp,
                    modelosveiculoResp,
                    projetosResp,
                    fornecedorAquisicaoResp,
                    motoristaSelecionadoResp,
                    eixosResp
                ] = await Promise.all([
                    api.get(`/fornecedor/active/true${paramsmotorista}`),
                    api.get(`/fornecedor/active/true${paramsfornecedorestransp}`),
                    api.get(`/fornecedor/active/true`),
                    api.get(`/tipoveiculo/active/true`),
                    api.get(`/combustivel/active/true`),
                    api.get(`/modeloveiculo/active/true`),
                    api.get(`/financas/projeto/active/true`),
                    dados.codfornecaquisicao
                        ? api.get(`/fornecedor/listforchange/${dados.codfornecaquisicao}`)
                        : Promise.resolve({ data: [] }),
                    dados.codmotorista
                        ? api.get(`/fornecedor/listforchange/${dados.codmotorista}`)
                        : Promise.resolve({ data: [] }),
                    dados.codveiculo
                        ? api.get(`/veiculo/eixos/${dados.codveiculo}`)
                        : Promise.resolve({ data: [] })
                ]);

                const motoristas = Array.isArray(motoristasResp.data) ? [...motoristasResp.data] : [];
                const fornecedorestransp = Array.isArray(
                    fornecedorestranspResp.data
                ) ? [...fornecedorestranspResp.data] : [];
                const fornecedoresgeral = Array.isArray(
                    fornecedoresgeralResp.data
                ) ? [...fornecedoresgeralResp.data] : [];
                const tiposveiculo = Array.isArray(
                    tiposveiculoResp.data?.data
                ) ? [...tiposveiculoResp.data.data] : [];
                const combustiveis = Array.isArray(combustiveisResp.data) ? [...combustiveisResp.data] : [];
                const modelosveiculo = Array.isArray(
                    modelosveiculoResp.data?.data
                ) ? [...modelosveiculoResp.data.data] : [];
                const projetos = Array.isArray(projetosResp.data) ? [...projetosResp.data] : [];
                const fornecedorAquisicao = Array.isArray(
                    fornecedorAquisicaoResp.data
                ) ? fornecedorAquisicaoResp.data : (
                    Array.isArray(fornecedorAquisicaoResp.data?.data) ? fornecedorAquisicaoResp.data.data : []
                );
                const motoristaSelecionado = Array.isArray(
                    motoristaSelecionadoResp.data
                ) ? motoristaSelecionadoResp.data : (
                    Array.isArray(motoristaSelecionadoResp.data?.data) ? motoristaSelecionadoResp.data.data : []
                );

                fornecedorAquisicao.forEach(item => {
                    if (!fornecedoresgeral.some(f => String(f.codfornecedor) === String(item.codfornecedor))) {
                        fornecedoresgeral.push(item);
                    }
                });

                const isFuncionario = (item) => {
                    return String(item.funcionario || item.FUNCIONARIO || '').toUpperCase() === ASIM;
                };

                motoristaSelecionado.forEach(item => {
                    if (isFuncionario(item) && !motoristas.some(
                        m => String(m.codfornecedor) === String(item.codfornecedor)
                    )) {
                        motoristas.push(item);
                    }
                });

                // garante selected item nos combos "listforchange", caso não esteja na lista ativa
                if (dados.codtipoveiculo && !tiposveiculo.some(
                    t => String(t.codtipoveiculo) === String(dados.codtipoveiculo)
                )) {
                    const tipoSelecionadoResp = await api.get(`/tipoveiculo/listforchange/${dados.codtipoveiculo}`);
                    const tipoSelecionado = Array.isArray(tipoSelecionadoResp.data) ? tipoSelecionadoResp.data : (
                        Array.isArray(tipoSelecionadoResp.data?.data) ? tipoSelecionadoResp.data.data : []
                    );

                    tipoSelecionado.forEach(item => {
                        if (!tiposveiculo.some(t => String(t.codtipoveiculo) === String(item.codtipoveiculo))) {
                            tiposveiculo.push(item);
                        }
                    });
                }

                if (dados.codcombustivel && !combustiveis.some(
                    c => String(c.codcombustivel) === String(dados.codcombustivel)
                )) {
                    const combustivelSelecionadoResp = await api.get(
                        `/combustivel/listforchange/${dados.codcombustivel}`
                    );
                    const combustivelSelecionado = Array.isArray(
                        combustivelSelecionadoResp.data
                    ) ? combustivelSelecionadoResp.data : (Array.isArray(
                        combustivelSelecionadoResp.data?.data
                    ) ? combustivelSelecionadoResp.data.data : []);
                    combustivelSelecionado.forEach(item => {
                        if (!combustiveis.some(c => String(c.codcombustivel) === String(item.codcombustivel))) {
                            combustiveis.push(item);
                        }
                    });
                }

                if (dados.codcombustivel2 && !combustiveis.some(
                    c => String(c.codcombustivel) === String(dados.codcombustivel2)
                )) {
                    const combustivel2SelecionadoResp = await api.get(
                        `/combustivel/listforchange/${dados.codcombustivel2}`
                    );
                    const combustivel2Selecionado = Array.isArray(
                        combustivel2SelecionadoResp.data
                    ) ? combustivel2SelecionadoResp.data : (
                        Array.isArray(
                            combustivel2SelecionadoResp.data?.data
                        ) ? combustivel2SelecionadoResp.data.data : []
                    );

                    combustivel2Selecionado.forEach(item => {
                        if (!combustiveis.some(c => String(c.codcombustivel) === String(item.codcombustivel))) {
                            combustiveis.push(item);
                        }
                    });
                }

                if (dados.codmodeloveiculo && !modelosveiculo.some(
                    m => String(m.codmodeloveiculo) === String(dados.codmodeloveiculo)
                )) {
                    const modeloSelecionadoResp = await api.get(
                        `/modeloveiculo/listforchange/${dados.codmodeloveiculo}`
                    );
                    const modeloSelecionado = Array.isArray(
                        modeloSelecionadoResp.data
                    ) ? modeloSelecionadoResp.data : (
                        Array.isArray(modeloSelecionadoResp.data?.data) ? modeloSelecionadoResp.data.data : []
                    );

                    modeloSelecionado.forEach(item => {
                        if (!modelosveiculo.some(m => String(m.codmodeloveiculo) === String(item.codmodeloveiculo))) {
                            modelosveiculo.push(item);
                        }
                    });
                }

                if (dados.codprojeto && !projetos.some(
                    p => String(p.codprojeto) === String(dados.codprojeto)
                )) {
                    const projetoSelecionadoResp = await api.get(
                        `/financas/projeto/listforchange/${dados.codprojeto}`
                    );
                    const projetoSelecionado = Array.isArray(
                        projetoSelecionadoResp.data
                    ) ? projetoSelecionadoResp.data : (
                        Array.isArray(projetoSelecionadoResp.data?.data) ? projetoSelecionadoResp.data.data : []
                    );

                    projetoSelecionado.forEach(item => {
                        if (!projetos.some(p => String(p.codprojeto) === String(item.codprojeto))) {
                            projetos.push(item);
                        }
                    });
                }

                this.setState({
                    combustiveis,
                    fornecedoresgeral,
                    fornecedorestransp,
                    modelosveiculo,
                    motoristas,
                    projetos,
                    tiposveiculo,
                    eixos: Array.isArray(eixosResp.data) ? eixosResp.data.map(e => ({
                        ...e,
                        seqeixo: e.seqeixo !== null ? Number(e.seqeixo) : null
                    })) : []
                });

                if (dados?.codveiculo) {
                    this.listaDocumentos(dados.codveiculo);
                    this.listaOpcionais(dados.codveiculo);
                }

                const listaModelos = modelosveiculo; // preenche a marca associada ao modelo

                if (dados?.codmodeloveiculo && listaModelos.length > 0) {
                    const modeloSelecionado = listaModelos.find(
                        (modelo) => modelo.codmodeloveiculo === Number(dados.codmodeloveiculo)
                    );

                    this.setState({ nomeMarcaAssociada: modeloSelecionado?.descmarcaveiculo || '' });
                }
            } catch (error) {
                console.error('Erro ao carregar veículo:', error.response?.data || error.message);

                this.handleOpenAlert('Erro ao carregar os dados do veículo!');
            }
        } else if (routeId === 'novo') {
            this.setState({
                isNewRecord: true,
                veiculo: {
                    ...veiculo,
                    descritivo: '',
                    obsseguro: '',
                    regimetrabalho: 0
                }
            });

            let paramsmotorista = `?page=1&limit=500&funcionario=S`;
            let paramsfornecedorestransp = `?page=1&limit=500&transportadora=S`;

            const [
                motoristas,
                fornecedorestransp,
                fornecedoresgeral,
                tiposveiculo,
                combustiveis,
                modelosveiculo,
                projetos
            ] = await Promise.all([
                api.get(`/fornecedor/active/true${paramsmotorista}`),
                api.get(`/fornecedor/active/true${paramsfornecedorestransp}`),
                api.get('/fornecedor/active/true'),
                api.get('/tipoveiculo/active/true'),
                api.get('/combustivel/active/true'),
                api.get('/modeloveiculo/active/true'),
                api.get('/financas/projeto/active/true')
            ]);

            this.setState({
                motoristas: motoristas.data,
                fornecedorestransp: fornecedorestransp.data,
                fornecedoresgeral: fornecedoresgeral.data,
                tiposveiculo: tiposveiculo.data?.data || [],
                combustiveis: combustiveis.data,
                modelosveiculo: modelosveiculo.data?.data || [],
                projetos: projetos.data
            });
        }

        await this.carregaOpcionais();
    };

    /* Carrega os opcionais */
    carregaOpcionais = async () => {
        try {
            const response = await api.get('/opcionalveiculo', {
                params: { sort: 'DESCOPCIONALVEICULO' }
            });

            const opcionais = Array.isArray(response.data) ? response.data : (
                Array.isArray(response.data?.data) ? response.data.data : []
            );

            this.setState({
                opcionais: opcionais.map(opcional => ({
                    ...opcional,
                    inativoopc: opcional.inativoopc ?? opcional.inativo ?? ANAO
                })).sort((a, b) => String(a.descopcionalveiculo || '').localeCompare(
                    String(b.descopcionalveiculo || ''),
                    'pt-BR',
                    { sensitivity: 'base' }
                ))
            });
        } catch (error) {
            console.error('Erro ao carregar opcionais:', error);

            this.handleOpenAlert('Erro ao carregar opcionais!');
        }
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { errors } = this.state;
        const { name, type, value, checked } = event.target;

        if (errors[name]) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    [name]: undefined
                }
            }));
        }

        // associa a capacidadepax ao codtipoveiculo
        if (name === 'codtipoveiculo') {
            const { tiposveiculo } = this.state;

            const tipoSelecionado = tiposveiculo.find(
                (tipo) => String(tipo.codtipoveiculo) === String(value)
            );

            this.setState(prev => ({
                veiculo: {
                    ...prev.veiculo,
                    codtipoveiculo: value,
                    capacidadepax: tipoSelecionado &&
                        tipoSelecionado.capacidadepax !== undefined &&
                        tipoSelecionado.capacidadepax !== null ? tipoSelecionado.capacidadepax : ''
                }
            }));

            return;
        }

        // busca 'modelosveiculo' no state
        if (name === 'codmodeloveiculo') {
            const { modelosveiculo } = this.state;

            const modeloSelecionado = modelosveiculo.find(
                (modelo) => modelo.codmodeloveiculo === Number(value)
            );

            this.setState({ nomeMarcaAssociada: modeloSelecionado?.descmarcaveiculo || '' });
        }

        // não converter para uppercase
        if (name === 'descritivo' || name === 'obsseguro') {
            this.setState(prevState => ({
                veiculo: {
                    ...prevState.veiculo,
                    [name]: value
                }
            }));

            return;
        }

        const camposUpper = [
            'nroveiculo',
            'descveiculo',
            'codrenavam',
            'placa',
            'chassi',
            'modelodechassi',
            'nrocarroceria'
        ];

        let adjustedValue;

        if (type === 'checkbox' && name === 'inativo') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (type === 'checkbox' && name === 'flex') {
            adjustedValue = checked ? ASIM : ANAO;

            this.setState(prevState => ({
                veiculo: {
                    ...prevState.veiculo,
                    flex: adjustedValue,
                    codcombustivel2: adjustedValue === ANAO ? '' : prevState.veiculo.codcombustivel2
                }
            }));

            return;
        } else if (type === 'checkbox' && name === 'veiculoproprio') {
            adjustedValue = checked ? ASIM : ANAO;

            this.setState(prevState => ({
                veiculo: {
                    ...prevState.veiculo,
                    veiculoproprio: adjustedValue,
                    abasteceveiculo: adjustedValue === ASIM ? '' : prevState.veiculo.abasteceveiculo
                }
            }));

            return;
        } else if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (type === 'radio') {
            adjustedValue = Number(value);
        } else if (camposUpper.includes(name)) {
            adjustedValue = value.toUpperCase();
        } else if (name === 'codcombustivel2') {
            adjustedValue = value ? Number(value) : '';
        } else {
            adjustedValue = value;
        }

        this.setState(prevState => ({
            veiculo: {
                ...prevState.veiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Evento onChange componentes documentos */
    onChangeDocumento = (event) => {
        const { name, type, value, checked } = event.target;

        // não converter para uppercase
        if (name === 'descritivodoc') {
            this.setState(prevState => ({
                documento: {
                    ...prevState.documento,
                    [name]: value
                }
            }));

            return;
        }

        const camposUpper = ['descricao'];

        let adjustedValue;

        if (type === 'checkbox' && name === 'inativodoc') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (type === 'radio') {
            adjustedValue = Number(value);
        } else if (camposUpper.includes(name)) {
            adjustedValue = value.toUpperCase();
        } else {
            adjustedValue = value;
        }

        this.setState((prevState) => ({
            documento: {
                ...prevState.documento,
                [name]: adjustedValue
            }
        }));
    };

    /* Evento onChange componentes opcionais */
    onChangeOpcional = (event) => {
        const { name, type, value, checked } = event.target;

        const camposUpper = ['descopcionalveiculo'];

        let adjustedValue;

        if (type === 'checkbox' && name === 'inativoopc') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (type === 'radio') {
            adjustedValue = Number(value);
        } else if (camposUpper.includes(name)) {
            adjustedValue = value.toUpperCase();
        } else if (name === 'codopcionalveiculo') {
            adjustedValue = Number(value);
        } else {
            adjustedValue = value;
        }

        this.setState((prevState) => ({
            opcional: {
                ...prevState.opcional,
                [name]: adjustedValue
            }
        }));
    };

    /* Insere um novo eixo */
    handleAddEixo = () => {
        this.setState(prevState => {
            const novaLista = [...prevState.eixos];

            // pega o maior seqeixo existente (ignora nulls)
            const maiorSeq = novaLista.reduce((max, eixo) => {
                const valor = eixo.seqeixo !== null ? Number(eixo.seqeixo) : 0;

                return valor > max ? valor : max;
            }, 0);

            const proximoSeq = maiorSeq + 1;

            novaLista.push({
                seqeixo: proximoSeq,
                nrorodas: ''
            });

            return { eixos: novaLista };
        });
    };

    /* Remove o eixo localmente */
    handleRemoveEixo = () => {
        this.setState(prevState => {
            const novaLista = [...prevState.eixos];

            novaLista.pop();

            return { eixos: novaLista };
        });
    };

    /* Altera o número de rodas */
    handleChangeRodas = (index, value) => {
        const num = parseInt(value);

        if (num >= 1 || value === '') {
            this.setState(prevState => {
                const novaLista = [...prevState.eixos];

                novaLista[index].nrorodas = value;

                return { eixos: novaLista };
            });
        }
    };

    /* Seleciona o arquivo TS do veículo */
    handleFileTS = (event) => {
        const file = event.target.files[0];

        if (file) {
            this.setState(prevState => ({
                arquivoTS: file,
                veiculo: {
                    ...prevState.veiculo,
                    localdocsegts: file.name
                }
            }));
        }
    };

    /* Remove o arquivo TS do veículo */
    handleDeleteFileTS = () => {
        this.setState(prevState => ({
            arquivoTS: null,
            veiculo: {
                ...prevState.veiculo,
                localdocsegts: ''
            }
        }), () => {
            if (this.inputFileTSRef.current) {
                this.inputFileTSRef.current.value = null;
            }
        });
    };

    /* Abre a confirmação de remoção do arquivo TS de veículo */
    handleOpenConfirmRemoveSeguroTS = () => {
        this.setState({ openConfirmRemoveSeguroTS: true });
    };

    /* Fecha a confirmação de remoção do arquivo TS de veículo */
    handleCloseConfirmRemoveSeguroTS = () => {
        this.setState({ openConfirmRemoveSeguroTS: false });
    };

    /* Seleciona o arquivo TS de documento */
    handleFileDocumentoTS = (event) => {
        const file = event.target.files[0];

        if (file) {
            this.setState(prevState => ({
                arquivoDocTS: file,
                documento: {
                    ...prevState.documento,
                    localdocts: file.name
                }
            }));
        }
    };

    /* Remove o arquivo TS de documento */
    handleDeleteFileDocumentoTS = () => {
        this.setState(prevState => ({
            arquivoDocTS: null,
            documento: {
                ...prevState.documento,
                localdocts: ''
            }
        }), () => {
            if (this.inputFileTSRef.current) {
                this.inputFileTSRef.current.value = null;
            }
        });
    };

    /* Abre a confirmação de remoção do arquivo TS de documento */
    handleOpenConfirmRemoveDocumentoTS = () => {
        this.setState({ openConfirmRemoveDocumentoTS: true });
    };

    /* Fecha a confirmação de remoção do arquivo TS de documento */
    handleCloseConfirmRemoveDocumentoTS = () => {
        this.setState({ openConfirmRemoveDocumentoTS: false });
    };

    /* Seleciona o arquivo de rede interna de veículo */
    handleFileRedeInterna = (event) => {
        const file = event.target.files[0];

        if (file) {
            this.setState(prevState => ({
                veiculo: {
                    ...prevState.veiculo,
                    localdocsegredeint: file.name
                },
                arquivoRedeInterna: file
            }));
        }
    };

    /* Remove o arquivo de rede interna de veículo */
    handleDeleteFileRedeInterna = () => {
        this.setState(prevState => ({
            arquivoRedeInterna: null,
            veiculo: {
                ...prevState.veiculo,
                localdocsegredeint: ''
            }
        }), () => {
            if (this.inputFileRedeInternaRef.current) {
                this.inputFileRedeInternaRef.current.value = null;
            }
        });
    };

    /* Abre a confirmação de remoção do arquivo de rede interna de veículo */
    handleOpenConfirmRemoveSeguroRedeInterna = () => {
        this.setState({ openConfirmRemoveSeguroRedeInterna: true });
    };

    /* Fecha a confirmação de remoção do arquivo de rede interna de veículo */
    handleCloseConfirmRemoveSeguroRedeInterna = () => {
        this.setState({ openConfirmRemoveSeguroRedeInterna: false });
    };

    /* Seleciona o arquivo de rede interna de documento */
    handleFileDocumentoRedeInterna = (event) => {
        const file = event.target.files[0];

        if (file) {
            this.setState(prevState => ({
                documento: {
                    ...prevState.documento,
                    localdocredeint: file.name
                },
                arquivoDocRedeInterna: file
            }));
        }
    };

    /* Remove o arquivo de rede interna de documento */
    handleDeleteFileDocumentoRedeInterna = () => {
        this.setState(prevState => ({
            arquivoDocRedeInterna: null,
            documento: {
                ...prevState.documento,
                localdocredeint: ''
            }
        }), () => {
            if (this.inputFileRedeInternaRef.current) {
                this.inputFileRedeInternaRef.current.value = null;
            }
        });
    };

    /* Abre a confirmação de remoção do arquivo de rede interna de documento */
    handleOpenConfirmRemoveDocumentoRedeInterna = () => {
        this.setState({ openConfirmRemoveDocumentoRedeInterna: true });
    };

    /* Fecha a confirmação de remoção do arquivo de rede interna de documento */
    handleCloseConfirmRemoveDocumentoRedeInterna = () => {
        this.setState({ openConfirmRemoveDocumentoRedeInterna: false });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload do veículo */
    getPayloadVeiculo = () => {
        const { eixos, veiculo } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();

        if (!codusuarioregistrou) {
            throw new Error('Código do usuário não encontrado!');
        }

        const fields = {
            codtipoveiculo: veiculo.codtipoveiculo || '',
            descveiculo: veiculo.descveiculo || '',
            veiculoproprio: veiculo.veiculoproprio || '',
            inativo: veiculo.inativo || '',
            capacidadepax: veiculo.capacidadepax || '',
            placa: veiculo.placa || '',
            situacao: veiculo.situacao || '',
            codfornecedorveiculo: veiculo.codfornecedorveiculo || '',
            figuranomapa: veiculo.figuranomapa || '',
            codrenavam: veiculo.codrenavam || '',
            chassi: veiculo.chassi || '',
            codcombustivel: veiculo.codcombustivel || '',
            anofabricacao: veiculo.anofabricacao || '',
            anomodelo: veiculo.anomodelo || '',
            codmodeloveiculo: veiculo.codmodeloveiculo || '',
            capacidadetanque: veiculo.capacidadetanque || '',
            modelodechassi: veiculo.modelodechassi || '',
            nrocarroceria: veiculo.nrocarroceria || '',
            nroveiculo: veiculo.nroveiculo || '',
            datacompraveiculo: veiculo.datacompraveiculo || '',
            codfornecaquisicao: veiculo.codfornecaquisicao || '',
            valoraquisicao: veiculo.valoraquisicao || '',
            nronf: veiculo.nronf || '',
            veiculousadoaquisicao: veiculo.veiculousadoaquisicao || '',
            regimetrabalho: veiculo.regimetrabalho || '',
            kmporlitro: veiculo.kmporlitro || '',
            hodometroultimarevisao: veiculo.hodometroultimarevisao || '',
            codmotorista: veiculo.codmotorista || '',
            codprojeto: veiculo.codprojeto || '',
            descritivo: veiculo.descritivo || '',
            codseguradora: veiculo.codseguradora || '',
            iniciovigenciaseguro: veiculo.iniciovigenciaseguro || '',
            fimvigenciaseguro: veiculo.fimvigenciaseguro || '',
            apoliceseguro: veiculo.apoliceseguro || '',
            franquiaseguro: veiculo.franquiaseguro || '',
            danosmatseguro: veiculo.danosmatseguro || '',
            danoscorpseguro: veiculo.danoscorpseguro || '',
            danosmoraisseguro: veiculo.danosmoraisseguro || '',
            obsseguro: veiculo.obsseguro || '',
            localdocsegts: veiculo.localdocsegts || '',
            localdocsegredeint: veiculo.localdocsegredeint || '',
            avisovencsegurodias: veiculo.avisovencsegurodias || '',
            flex: veiculo.flex || '',
            codcombustivel2: veiculo.codcombustivel2 || '',
            abasteceveiculo: veiculo.abasteceveiculo || '',
            codusuarioregistrou,
            eixos: JSON.stringify(eixos)
        };

        return appendFieldsToFormData(fields);
    };

    /* Troca a aba superior */
    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue });
    };

    /* Reinicia o state do documento */
    resetDocumentoState = () => ({
        documento: {
            chave: '',
            descricao: '',
            descritivodoc: '',
            vencimento: '',
            avisodiasantecedencia: '',
            localdocts: '',
            localdocredeint: '',
            inativodoc: ANAO
        },
        arquivoDocTS: null,
        arquivoDocRedeInterna: null,
        errors: {}
    });

    /* Sincroniza o novo documento com o novo veículo */
    sincronizaDocumentos = async (codveiculo) => {
        const { documentosveiculo } = this.state;

        if (!codveiculo) return;

        const listaDocumentos = Array.isArray(documentosveiculo) ? documentosveiculo : [];

        const documentosPendentes = listaDocumentos.filter(
            doc => !doc.chave || String(doc.chave).startsWith('tmp-doc-')
        );

        const codusuarioregistrou = getCodUsuarioRegistrou();

        for (const doc of documentosPendentes) {
            const formData = new FormData();

            formData.append('descricao', doc.descricao || '');
            formData.append('descritivodoc', doc.descritivodoc || '');
            formData.append('vencimento', doc.vencimento || '');
            formData.append('avisodiasantecedencia', doc.avisodiasantecedencia || '');
            formData.append('localdocts', doc.localdocts || '');
            formData.append('localdocredeint', doc.localdocredeint || '');
            formData.append('inativodoc', doc.inativodoc || '');
            formData.append('codusuarioregistrou', codusuarioregistrou);
            formData.append('codveiculo', codveiculo);

            await api.post('/docveiculo', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        }

        await this.listaDocumentos(codveiculo);
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { veiculo, isNewRecord } = this.state;
        const { history, loadVeiculos } = this.props;

        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        const comboErrors = validateComboFields(veiculo, [
            {
                field: 'codtipoveiculo',
                message: 'Selecione um tipo de veículo válido'
            },
            {
                field: 'codfornecedorveiculo',
                message: 'Selecione um fornecedor de veículo válido'
            }
        ]);

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione registros válidos nos campos indicados em vermelho!');

            return;
        }

        try {
            let codveiculoSalvo = veiculo.codveiculo;

            const formData = this.getPayloadVeiculo();

            if (isNewRecord) {
                const response = await api.post('/veiculo', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                codveiculoSalvo = response?.data?.codveiculo;

                if (!codveiculoSalvo) {
                    throw new Error('O veículo foi enviado, mas o código salvo não foi retornado pelo backend!')
                }
            } else {
                await api.put(`/veiculo/${veiculo.codveiculo}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                codveiculoSalvo = veiculo.codveiculo;
            }

            if (loadVeiculos) loadVeiculos();

            await this.sincronizaDocumentos(codveiculoSalvo);
            await this.sincronizaOpcionais(codveiculoSalvo, isNewRecord);

            history.push('/frotas/veiculo');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.message ||
                'Erro ao salvar!'
            );
        }
    };

    /* Sincroniza os opcionais vinculados ao veículo com o banco */
    sincronizaOpcionais = async (codveiculo, isNewRecord = false) => {
        const { opcionaisveiculo } = this.state;

        if (!codveiculo) {
            return;
        }

        try {
            // veículo novo ainda não possui opcionais no banco
            const opcionaisBanco = isNewRecord ? [] : (
                await api.get(`/opcionaisdoveiculo/${codveiculo}`)
            ).data || [];
            const opcionaisBancoIds = opcionaisBanco.map(o => o.codopcionalveiculo);
            const opcionaisGridIds = opcionaisveiculo.map(o => o.codopcionalveiculo);

            // remove os opcionais que saíram da grid
            for (const opc of opcionaisBanco) {
                if (!opcionaisGridIds.includes(opc.codopcionalveiculo)) {
                    await api.delete(`/opcionaisdoveiculo/${opc.chave}`);
                }
            }

            // insere os opcionais que são novos na grid
            for (const id of opcionaisGridIds) {
                if (!opcionaisBancoIds.includes(id)) {
                    await api.post(`/opcionaisdoveiculo`, {
                        codveiculo,
                        codopcionalveiculo: id
                    });
                }
            }
        } catch (error) {
            console.error('Erro ao sincronizar opcionais do veículo:', error);

            this.handleOpenAlert('Erro ao salvar opcionais do veículo!');

            throw error;
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/veiculo');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schemaVeiculo, veiculo } = this.state;

        let errors = {};

        const requiredFields = [
            'nroveiculo',
            'codtipoveiculo',
            'codfornecedorveiculo'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, veiculo[field], schemaVeiculo);

            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Valida os campos obrigatórios ao salvar o documento */
    validationRequiredFieldsDocumentos() {
        const { schemaDocumento, documento } = this.state;

        let errors = {};

        const requiredFields = ['descricao'];

        requiredFields.forEach(field => {
            const error = validateField(field, documento[field], schemaDocumento);

            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Valida os campos obrigatórios ao salvar o opcional */
    validationRequiredFieldsOpcionais() {
        const { schemaOpcional, opcional } = this.state;

        let errors = {};

        const requiredFields = ['descopcionalveiculo'];

        requiredFields.forEach(field => {
            const error = validateField(field, opcional[field], schemaOpcional);

            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Insere o opcional na grid */
    handleInsertOpcional = () => {
        const { opcional, opcionais, opcionaisveiculo } = this.state;
        const id = opcional.codopcionalveiculo;

        if (!id || id <= 0) {
            this.handleOpenAlert('Selecione um opcional para adicionar na grid!');

            return;
        }

        const jaExiste = opcionaisveiculo.some(item => item.codopcionalveiculo === id);

        if (jaExiste) {
            this.handleOpenAlert('O opcional selecionado já foi adicionado na grid!');

            return;
        }

        const opcionalSelecionado = opcionais.find(opc => opc.codopcionalveiculo === id);

        if (!opcionalSelecionado) {
            this.handleOpenAlert('Opcional não encontrado!');

            return;
        }

        this.setState(prevState => ({
            opcionaisveiculo: this.ordenarOpcionaisVeiculo([
                ...prevState.opcionaisveiculo,
                opcionalSelecionado
            ]),
            opcional: {
                codopcionalveiculo: 0,
                descopcionalveiculo: '',
                inativoopc: ANAO
            },
            openModalOpcionais: false
        }));
    };

    /* Insere o documento */
    handleInsertDocumento = () => {
        const { documentosveiculo } = this.state;
        const novos = [...documentosveiculo];

        novos.push({
            descricao: '',
            chave: ''
        });

        this.setState({ documentosveiculo: novos });
    };

    /* Clicar para salvar o documento */
    onClickSaveDocumento = async () => {
        const { documento, veiculo, arquivoDocTS, arquivoDocRedeInterna } = this.state;

        let errors = this.validationRequiredFieldsDocumentos();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const codusuarioregistrou = getCodUsuarioRegistrou();

            if (!veiculo.codveiculo) {
                const chaveTemporaria = documento.chave && String(
                    documento.chave
                ).startsWith('tmp-doc-') ? documento.chave : `tmp-doc-${Date.now()}`;

                const documentoLocal = {
                    ...documento,
                    chave: chaveTemporaria,
                    codveiculo: '',
                    codusuarioregistrou: Number(codusuarioregistrou),
                    arquivoDocTS: arquivoDocTS || null,
                    arquivoDocRedeInterna: arquivoDocRedeInterna || null
                };

                this.setState(prevState => {
                    const jaExiste = prevState.documentosveiculo.some(
                        doc => String(doc.chave) === String(chaveTemporaria)
                    );

                    const documentosveiculo = jaExiste ? prevState.documentosveiculo.map(
                        doc => String(doc.chave) === String(chaveTemporaria) ? documentoLocal : doc
                    ) : [...prevState.documentosveiculo, documentoLocal];

                    return {
                        documentosveiculo,
                        openModalDocumentos: false,
                        ...this.resetDocumentoState()
                    };
                });

                return;
            }

            const formData = new FormData();

            formData.append('descricao', documento.descricao || '');
            formData.append('descritivodoc', documento.descritivodoc || '');
            formData.append('vencimento', documento.vencimento || '');
            formData.append('avisodiasantecedencia', documento.avisodiasantecedencia || '');
            formData.append('localdocts', documento.localdocts || '');
            formData.append('localdocredeint', documento.localdocredeint || '');
            formData.append('inativodoc', documento.inativodoc || '');
            formData.append('codusuarioregistrou', codusuarioregistrou);
            formData.append('codveiculo', veiculo.codveiculo);

            let response;

            if (documento.chave) {
                response = await api.put(`/docveiculo/${documento.chave}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                response = await api.post('/docveiculo', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            if (response.status === 200) {
                await this.listaDocumentos();

                this.setState({
                    openModalDocumentos: false,
                    ...this.resetDocumentoState()
                });
            } else {
                this.handleOpenAlert('Erro ao salvar documento!');
            }
        } catch (error) {
            console.error('Erro ao salvar documento:', error);

            this.handleOpenAlert(
                error?.response?.data?.error ||
                error?.response?.data?.mensagem ||
                error?.message ||
                'Erro ao salvar documento!'
            );
        }
    };

    /* Abre o modal para a exclusão do documento */
    handleOpenDeleteDocumento = (chave, descricao, chaveExibicao) => {
        this.setState({
            openConfirmDeleteDocumento: true,
            documentoASerExcluido: chave,
            documentoChaveASerExcluida: chaveExibicao || chave,
            documentoDescASerExcluido: descricao || ''
        });
    };

    /* Fecha o modal de exclusão do documento */
    handleCloseDeleteDocumento = () => {
        this.setState({
            openConfirmDeleteDocumento: false,
            documentoASerExcluido: null,
            documentoChaveASerExcluida: '',
            documentoDescASerExcluido: ''
        });
    };

    /* Confirma a exclusão do documento */
    handleConfirmDeleteDocumento = async () => {
        const { documentoASerExcluido } = this.state;

        if (!documentoASerExcluido) {
            this.handleOpenAlert('Chave do documento inválida!');
        }

        if (String(documentoASerExcluido).startsWith('tmp-doc-')) {
            this.setState(prevState => ({
                documentosveiculo: prevState.documentosveiculo.filter(
                    doc => String(doc.chave) !== String(documentoASerExcluido)
                ),
                openConfirmDeleteDocumento: false,
                documentoASerExcluido: null,
                documentoChaveASerExcluida: '',
                documentoDescASerExcluido: ''
            }));

            return;
        }

        try {
            await api.delete(`/docveiculo/${documentoASerExcluido}`);
            await this.listaDocumentos();

            this.setState({
                openConfirmDeleteDocumento: false,
                documentoASerExcluido: null,
                documentoDescASerExcluido: ''
            });
        } catch (error) {
            console.error('Erro ao excluir documento:', error);

            this.handleOpenAlert('Erro ao excluir o documento!');

            this.setState({ openConfirmDeleteDocumento: false });
        }
    };

    /* Altera o documento */
    handleChangeDocumento = (doc) => {
        this.setState({
            documento: {
                ...doc
            },
            arquivoDocTS: doc.arquivoDocTS || null,
            arquivoDocRedeInterna: doc.arquivoDocRedeInterna || null,
            openModalDocumentos: true,
            isView: false
        });
    };

    /* Modal de documentos */
    handleOpenModalDocumentos = async () => {
        const { veiculo } = this.state;

        try {
            const response = await api.get('/docveiculo/active/true');

            this.setState({
                documentosDisponiveis: Array.isArray(response.data?.data) ? response.data.data : [],
                openModalDocumentos: true,
                documentoSelecionado: null,
                documento: {
                    chave: '',
                    descricao: '',
                    descritivodoc: '',
                    vencimento: '',
                    localdocts: '',
                    localdocredeint: '',
                    inativodoc: ANAO,
                    codusuarioregistrou: '',
                    datahoraregistro: '',
                    avisodiasantecedencia: '',
                    codveiculo: veiculo.codveiculo || ''
                },
                arquivoDocTS: null,
                arquivoDocRedeInterna: null
            });
        } catch (error) {
            console.error('Erro ao buscar documentos de veículo:', error);
        }
    };

    /* Clicar para salvar o opcional */
    onClickSaveOpcional = async () => {
        const { opcional } = this.state;

        let errors = this.validationRequiredFieldsOpcionais();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            let response;

            const payload = {
                descopcionalveiculo: opcional.descopcionalveiculo,
                inativoopc: opcional.inativoopc || ANAO
            };

            if (opcional.codopcionalveiculo) {
                response = await api.put(`/opcionalveiculo/${opcional.codopcionalveiculo}`, payload);
            } else {
                response = await api.post(`/opcionalveiculo`, payload);
            }

            if (response.status === 200) {
                this.setState(prev => ({
                    opcionais: prev.opcionais.map(
                        item => item.codopcionalveiculo === opcional.codopcionalveiculo ? {
                            ...item,
                            descopcionalveiculo: payload.descopcionalveiculo,
                            inativoopc: payload.inativoopc
                        } : item
                    ),
                    opcionaisveiculo: prev.opcionaisveiculo.map(
                        item => item.codopcionalveiculo === opcional.codopcionalveiculo ? {
                            ...item,
                            descopcionalveiculo: payload.descopcionalveiculo,
                            inativoopc: payload.inativoopc
                        } : item
                    ),
                    openModalOne: false,
                    openModalTwo: false,
                }));

                await this.carregaOpcionais();
            } else {
                this.handleOpenAlert('Erro ao salvar opcional!');
            }
        } catch (error) {
            console.error('Erro ao salvar opcional:', error);

            this.handleOpenAlert('Erro ao salvar opcional!');
        }
    };

    /* Abre o modal de opcionais */
    handleOpenModalOpcionais = async () => {
        try {
            await this.carregaOpcionais();

            this.setState({
                openModalOpcionais: true,
                opcional: {
                    codopcionalveiculo: 0,
                    descopcionalveiculo: '',
                    inativoopc: ANAO
                }
            });
        } catch (error) {
            console.error('Erro ao buscar opcionais de veículo:', error);
            this.handleOpenAlert('Erro ao buscar opcionais de veículo!');
        }
    };

    /* Fecha o modal de opcionais */
    handleCloseModalOpcionais = () => {
        this.setState({ openModalOpcionais: false });
    };

    /* Abre o modal de edição/visualização de opcionais */
    handleOpenModalOne = (isView = false) => {
        const { opcional, opcionais } = this.state;
        const id = opcional.codopcionalveiculo;

        if (!id || id <= 0) {
            this.handleOpenAlert(
                isView ? 'Selecione um opcional para visualizar!' : 'Selecione um opcional para editar!'
            );

            return;
        }

        // busca o opcional completo na lista
        const opcionalSelecionado = opcionais.find(opc => opc.codopcionalveiculo === id);

        if (!opcionalSelecionado) {
            this.handleOpenAlert('Opcional não encontrado!');

            return;
        }

        this.setState({
            opcional: {
                codopcionalveiculo: opcionalSelecionado.codopcionalveiculo,
                descopcionalveiculo: opcionalSelecionado.descopcionalveiculo,
                inativoopc: opcionalSelecionado.inativoopc ?? opcionalSelecionado.inativo ?? ANAO
            },
            isView: isView,
            openModalOne: true
        });
    };

    /* Fecha o modal de edição/visualização de opcionais */
    handleCloseModalOne = () => {
        this.setState({ openModalOne: false, isView: false });
    };

    /* Abre o modal de cadastro de opcionais */
    handleOpenModalTwo = () => {
        this.setState({
            opcional: {
                codopcionalveiculo: 0,
                descopcionalveiculo: '',
                inativoopc: ANAO
            },
            openModalTwo: true,
            isView: false
        });
    };

    /* Fecha o modal de cadastro de opcionais */
    handleCloseModalTwo = () => {
        this.setState({ openModalTwo: false });
    };

    /* Abre o modal de exclusão do opcional */
    handleOpenDeleteOpcional = () => {
        const { opcional, opcionais } = this.state;
        const id = opcional.codopcionalveiculo;

        if (!id || id <= 0) {
            this.handleOpenAlert('Selecione um opcional para excluir!');

            return;
        }

        const opcionalSelecionado = opcionais.find(
            opc => Number(opc.codopcionalveiculo) === Number(id)
        );

        this.setState({
            openConfirmDeleteOpcional: true,
            opcionalASerExcluido: id,
            opcionalDescASerExcluido: opcionalSelecionado?.descopcionalveiculo || opcional.descopcionalveiculo || ''
        });
    };

    /* Modal de remoção de opcional da grid */
    handleConfirmRemoveOpcional = () => {
        const { opcionalASerRemovido, opcionaisveiculo } = this.state;

        const novaLista = opcionaisveiculo.filter(
            opc => opc.codopcionalveiculo !== opcionalASerRemovido
        );

        this.setState({
            opcionaisveiculo: this.ordenarOpcionaisVeiculo(novaLista),
            openConfirmRemoveOpcional: false,
            opcionalASerRemovido: null,
            opcionalDescASerRemovido: ''
        });
    };

    /* Abre o modal de confirmação da remoção do opcional da grid */
    handleOpenRemoveOpcional = (codopcionalveiculo, descopcionalveiculo) => {
        this.setState({
            openConfirmRemoveOpcional: true,
            opcionalASerRemovido: codopcionalveiculo,
            opcionalDescASerRemovido: descopcionalveiculo || ''
        });
    };

    /* Fecha o modal de confirmação da remoção do opcional da grid */
    handleCloseRemoveOpcional = () => {
        this.setState({
            openConfirmRemoveOpcional: false,
            opcionalASerRemovido: null,
            opcionalDescASerRemovido: ''
        });
    };

    /* Fecha o modal de exclusão do opcional */
    handleCloseDeleteOpcional = () => {
        this.setState({
            openConfirmDeleteOpcional: false,
            opcionalASerExcluido: null,
            opcionalDescASerExcluido: ''
        });
    };

    /* Confirma a exclusão do opcional do banco de dados */
    handleConfirmDeleteOpcional = async () => {
        const { opcionalASerExcluido } = this.state;

        try {
            const response = await api.delete(`/opcionalveiculo/${opcionalASerExcluido}`);

            if (response.status === 200) {
                this.setState({
                    opcional: {
                        codopcionalveiculo: 0,
                        descopcionalveiculo: '',
                        inativoopc: ANAO
                    },
                    openConfirmDeleteOpcional: false,
                    opcionalASerExcluido: null,
                    opcionalDescASerExcluido: ''
                });
                this.carregaOpcionais();
            } else {
                this.handleOpenAlert('Erro ao excluir opcional!');
            }
        } catch (error) {
            console.error('Erro ao excluir opcional:', error);

            this.handleOpenAlert('Erro ao excluir opcional!');
        }
    };

    /* Trata os campos monetários */
    handleChangeValorMonetario = (e) => {
        const numero = parseCurrencyInputValue(e.target.value);

        this.setState(prevState => ({
            veiculo: {
                ...prevState.veiculo,
                [name]: numero
            }
        }));
    };

    /* Aceita somente dígitos */
    handleNumericChange = (e) => {
        const { name, value } = e.target;
        const onlyDigits = getOnlyDigits(value);

        this.setState(prev => ({
            veiculo: {
                ...prev.veiculo,
                [name]: onlyDigits
            }
        }));
    };

    /* Fecha o modal de documentos */
    handleCloseModalDocumentos = () => {
        this.setState({
            openModalDocumentos: false,
            ...this.resetDocumentoState()
        });
    };

    /* Confirma a remoção do arquivo TS de veículo */
    handleConfirmRemoveSeguroTS = () => {
        this.handleCloseConfirmRemoveSeguroTS();
        this.handleDeleteFileTS();
    };

    /* Confirma a remoção do arquivo de rede interna de veículo */
    handleConfirmRemoveSeguroRedeInterna = () => {
        this.handleCloseConfirmRemoveSeguroRedeInterna();
        this.handleDeleteFileRedeInterna();
    };

    /* Confirma a remoção do arquivo TS de documento */
    handleConfirmRemoveDocumentoTS = () => {
        this.handleCloseConfirmRemoveDocumentoTS();
        this.handleDeleteFileDocumentoTS();
    };

    /* Confirma a remoção do arquivo de rede interna de documento */
    handleConfirmRemoveDocumentoRedeInterna = () => {
        this.handleCloseConfirmRemoveDocumentoRedeInterna();
        this.handleDeleteFileDocumentoRedeInterna();
    };

    /* Trata os campos numéricos positivos */
    handlePositiveNumberChange = (event, callback = this.onChange) => {
        const valor = parseInt(event.target.value);

        if (valor >= 1 || event.target.value === '') {
            callback(event);
        }
    };

    /* Trata os campos numéricos positivos de documento */
    handlePositiveNumberDocumentoChange = (event) => {
        this.handlePositiveNumberChange(event, this.onChangeDocumento);
    };

    render() {
        const {
            activeTab,
            arquivoDocRedeInterna,
            arquivoDocTS,
            arquivoRedeInterna,
            arquivoTS,
            combustiveis,
            documento,
            documentoASerExcluido,
            documentoChaveASerExcluida,
            documentoDescASerExcluido,
            documentosveiculo,
            eixos,
            errors,
            fornecedoresgeral,
            fornecedorestransp,
            isView,
            messageAlert,
            modelosveiculo,
            motoristas,
            nomeMarcaAssociada,
            opcionais,
            opcionaisveiculo,
            opcional,
            opcionalASerExcluido,
            opcionalASerRemovido,
            opcionalDescASerExcluido,
            opcionalDescASerRemovido,
            openAlert,
            openConfirmDeleteDocumento,
            openConfirmDeleteOpcional,
            openConfirmRemoveDocumentoRedeInterna,
            openConfirmRemoveDocumentoTS,
            openConfirmRemoveOpcional,
            openConfirmRemoveSeguroRedeInterna,
            openConfirmRemoveSeguroTS,
            openModalDocumentos,
            openModalOne,
            openModalOpcionais,
            openModalTwo,
            projetos,
            tiposveiculo,
            veiculo
        } = this.state;

        const {
            actionIcon,
            iconGroup
        } = this.estilo;

        const isUploadDisabledTS = !!(arquivoDocTS || documento.localdocts);
        const isDeleteDisabledTS = !(arquivoDocTS || documento.localdocts);
        const isUploadDisabledRedeInterna = !!(arquivoDocRedeInterna || documento.localdocredeint);
        const isDeleteDisabledRedeInterna = !(arquivoDocRedeInterna || documento.localdocredeint);
        const isUploadDisabledSegTS = !!(arquivoTS || veiculo.localdocsegts);
        const isDeleteDisabledSegTS = !(arquivoTS || veiculo.localdocsegts);
        const isUploadDisabledSegRedeInterna = !!(arquivoRedeInterna || veiculo.localdocsegredeint);
        const isDeleteDisabledSegRedeInterna = !(arquivoRedeInterna || veiculo.localdocsegredeint);

        return (
            <div>
                <AppBar
                    position="static"
                    color="default"
                >
                    <Tabs
                        value={activeTab}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label="Identificação" />
                        <Tab label="Eixos" />
                        <Tab label="Geral" />
                        <Tab label="Opcionais" />
                        <Tab label="Seguro" />
                        <Tab label="Documentos" />
                    </Tabs>
                </AppBar>

                {/* ABA IDENTIFICAÇÃO */}
                {activeTab === 0 &&
                    <TabContainer>
                        <CardContent>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                style={{ flexWrap: 'wrap' }}
                            >
                                <Typography
                                    component="h1"
                                    variant="h3"
                                >
                                    Veículo {veiculo.codveiculo}
                                </Typography>

                                <FormControlLabel
                                    label={veiculo.inativo === ANAO ? 'Ativo' : 'Inativo'}
                                    control={
                                        <Switch
                                            checked={veiculo.inativo === ANAO}
                                            name="inativo"
                                            onChange={this.onChange}
                                            color="primary"
                                            disabled={isView}
                                        />
                                    }
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                alignItems="center"
                                style={{
                                    flexWrap: 'wrap',
                                    gap: 16
                                }}
                            >
                                <TextField
                                    label="Veículo"
                                    name="nroveiculo"
                                    value={veiculo.nroveiculo || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    helperText={errors.nroveiculo || ''}
                                    error={!!errors.nroveiculo}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 220
                                    }}
                                />

                                <Box
                                    style={{
                                        flex: '0 0 auto',
                                        minWidth: 100,
                                        textAlign: 'center'
                                    }}
                                >
                                    <Typography variant="subtitle2">
                                        Hodômetro
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        style={{ fontWeight: 'bold' }}
                                    >
                                        {veiculo.kmatual !== null &&
                                            veiculo.kmatual !== undefined ? veiculo.kmatual.toLocaleString() : '0'
                                        }
                                    </Typography>
                                </Box>
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                alignItems="center"
                                style={{
                                    flexWrap: 'wrap',
                                    gap: 16
                                }}
                            >
                                <TextField
                                    label="Descrição"
                                    name="descveiculo"
                                    value={veiculo.descveiculo || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 220
                                    }}
                                />

                                <FormControlLabel
                                    label={'Flex'}
                                    control={
                                        <Checkbox
                                            checked={(veiculo.flex === ASIM)}
                                            name="flex"
                                            onChange={this.onChange}
                                            color="primary"
                                            disabled={isView}
                                        />
                                    }
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <FormControl
                                    style={{
                                        flex: 1,
                                        minWidth: 120
                                    }}
                                >
                                    <ComboPadrao
                                        name={'codcombustivel'}
                                        label={'Combustível'}
                                        value={veiculo.codcombustivel}
                                        onChange={this.onChange}
                                        fieldId={'codcombustivel'}
                                        listItems={combustiveis}
                                        fieldDescription={'desccombustivel'}
                                    />
                                </FormControl>

                                {veiculo.flex === ASIM && (
                                    <FormControl
                                        variant="outlined"
                                        disabled={isView}
                                        style={{
                                            flex: 1,
                                            minWidth: 120
                                        }}
                                    >
                                        <ComboPadrao
                                            name={'codcombustivel2'}
                                            label={'Combustível 2'}
                                            value={veiculo.codcombustivel2}
                                            onChange={this.onChange}
                                            fieldId={'codcombustivel'}
                                            listItems={combustiveis}
                                            fieldDescription={'desccombustivel'}
                                        />
                                    </FormControl>
                                )}

                                <TextField
                                    label="Consumo (KM/Litro)"
                                    name="kmporlitro"
                                    value={getCurrencyInputValue(veiculo.kmporlitro)}
                                    variant="outlined"
                                    onChange={this.handleChangeValorMonetario}
                                    disabled={isView}
                                    type="text"
                                    style={{
                                        flex: 1,
                                        minWidth: 120
                                    }}
                                />

                                <TextField
                                    label="Capacidade do tanque"
                                    name="capacidadetanque"
                                    value={getCurrencyInputValue(veiculo.capacidadetanque)}
                                    variant="outlined"
                                    onChange={this.handleChangeValorMonetario}
                                    disabled={isView}
                                    type="text"
                                    style={{
                                        flex: 1,
                                        minWidth: 120
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Placa"
                                    name="placa"
                                    value={veiculo.placa || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        flex: '0 1 150px',
                                        minWidth: 140
                                    }}
                                />

                                <FormControl
                                    style={{
                                        flex: 1,
                                        minWidth: 180
                                    }}
                                >
                                    <ComboPadrao
                                        name={'codtipoveiculo'}
                                        label={'Tipo de veículo'}
                                        value={veiculo.codtipoveiculo}
                                        onChange={this.onChange}
                                        fieldId={'codtipoveiculo'}
                                        listItems={tiposveiculo}
                                        fieldDescription={'desctipoveiculo'}
                                        error={!!errors.codtipoveiculo}
                                        helperText={errors.codtipoveiculo || ''}
                                    />
                                </FormControl>

                                <TextField
                                    label="Código RENAVAM"
                                    name="codrenavam"
                                    value={veiculo.codrenavam || ''}
                                    variant="outlined"
                                    onChange={this.handleNumericChange}
                                    disabled={isView}
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9]*',
                                        maxLength: 50
                                    }}
                                    style={{
                                        flex: 1,
                                        minWidth: 220
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                alignItems="center"
                                style={{ gap: 12 }}
                            >
                                <FormControl
                                    style={{
                                        flex: 1,
                                        minWidth: 240
                                    }}
                                >
                                    <ComboPadrao
                                        name={'codmodeloveiculo'}
                                        label={'Modelo'}
                                        value={veiculo.codmodeloveiculo}
                                        onChange={this.onChange}
                                        fieldId={'codmodeloveiculo'}
                                        listItems={modelosveiculo}
                                        fieldDescription={'descmodeloveiculo'}
                                    />
                                </FormControl>

                                {nomeMarcaAssociada && (
                                    <Box
                                        style={{
                                            flex: 1,
                                            minWidth: 180
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            style={{ fontWeight: 'bold' }}
                                        >
                                            {nomeMarcaAssociada}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <FormControl
                                    style={{
                                        flex: 1,
                                        minWidth: 240
                                    }}
                                >
                                    <ComboPadrao
                                        name={'codfornecedorveiculo'}
                                        label={'Fornecedor do veículo'}
                                        value={veiculo.codfornecedorveiculo}
                                        onChange={this.onChange}
                                        fieldId={'codfornecedor'}
                                        listItems={fornecedorestransp}
                                        fieldDescription={'fantasia'}
                                        error={!!errors.codfornecedorveiculo}
                                        helperText={errors.codfornecedorveiculo || ''}
                                    />
                                </FormControl>

                                <FormControl
                                    style={{
                                        flex: 1,
                                        minWidth: 220
                                    }}
                                >
                                    <ComboPadrao
                                        name={'codprojeto'}
                                        label={'Projeto'}
                                        value={veiculo.codprojeto}
                                        onChange={this.onChange}
                                        fieldId={'codprojeto'}
                                        listItems={projetos}
                                        fieldDescription={'descprojeto'}
                                    />
                                </FormControl>
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Chassi"
                                    name="chassi"
                                    value={veiculo.chassi || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 120
                                    }}
                                />

                                <TextField
                                    label="Modelo de chassi"
                                    name="modelodechassi"
                                    value={veiculo.modelodechassi || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 120
                                    }}
                                />

                                <TextField
                                    label="Número carroceria"
                                    name="nrocarroceria"
                                    value={veiculo.nrocarroceria || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 120
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Ano fabricação"
                                    name="anofabricacao"
                                    value={getInputValue(veiculo.anofabricacao)}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    onChange={this.handlePositiveNumberChange}
                                    style={{
                                        flex: 1,
                                        minWidth: 140
                                    }}
                                />

                                <TextField
                                    label="Ano modelo"
                                    name="anomodelo"
                                    value={getInputValue(veiculo.anomodelo)}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    onChange={this.handlePositiveNumberChange}
                                    style={{
                                        flex: 1,
                                        minWidth: 140
                                    }}
                                />
                            </Box>

                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {/* ABA EIXOS */}
                {activeTab === 1 &&
                    <TabContainer>
                        <CardContent>
                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                Veículo {veiculo.codveiculo}
                            </Typography>

                            <br />

                            <TableContainer
                                component={Paper}
                                fullWidth
                                style={{
                                    maxHeight: 400,
                                    overflowX: 'auto',
                                    overflowY: 'auto'
                                }}
                            >
                                <Table
                                    size="small"
                                    style={{ tableLayout: 'fixed' }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                align="center"
                                                style={{ width: '33%' }}
                                            >
                                                <strong>Eixo</strong>
                                            </TableCell>

                                            <TableCell
                                                align="center"
                                                style={{ width: '33%' }}
                                            >
                                                <strong>Nº Rodas</strong>
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                style={{ width: '34%', minWidth: 160 }}
                                            >
                                                <Box
                                                    display="flex"
                                                    justifyContent="flex-end"
                                                    style={{ gap: 8 }}
                                                >
                                                    <Button
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={this.handleRemoveEixo}
                                                        disabled={isView || eixos.length === 0}
                                                    >
                                                        Excluir
                                                    </Button>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={this.handleAddEixo}
                                                        disabled={isView}
                                                    >
                                                        Inserir
                                                    </Button>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {eixos.map((eixo, index) => (
                                            <TableRow key={index}>
                                                <TableCell
                                                    align="center"
                                                    style={{ verticalAlign: 'middle' }}
                                                >
                                                    {eixo.seqeixo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={{ verticalAlign: 'middle' }}
                                                >
                                                    <TextField
                                                        value={eixo.nrorodas}
                                                        type="number"
                                                        onChange={(e) => this.handleChangeRodas(index, e.target.value)}
                                                        variant="outlined"
                                                        size="small"
                                                        style={{ width: 80 }}
                                                        disabled={isView}
                                                        inputProps={{
                                                            min: 1,
                                                            style: { textAlign: 'center' }
                                                        }}
                                                    />
                                                </TableCell>

                                                <TableCell />
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {/* ABA GERAL */}
                {activeTab === 2 &&
                    <TabContainer>
                        <CardContent>
                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                Veículo {veiculo.codveiculo}
                            </Typography>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Capacidade de pax"
                                    name="capacidadepax"
                                    value={getInputValue(veiculo.capacidadepax)}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    onChange={this.handlePositiveNumberChange}
                                    style={{
                                        flex: 1,
                                        minWidth: 120
                                    }}
                                />

                                <TextField
                                    label="Hodômetro última revisão"
                                    name="hodometroultimarevisao"
                                    value={getInputValue(veiculo.hodometroultimarevisao)}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    onChange={this.handlePositiveNumberChange}
                                    style={{
                                        flex: 1,
                                        minWidth: 120
                                    }}
                                />

                                <FormControl
                                    variant="filled"
                                    disabled={isView}
                                    style={{
                                        flex: 1,
                                        minWidth: 120
                                    }}
                                >
                                    <InputLabel
                                        htmlFor="outlined-age-native-simple"
                                        shrink={true}
                                        style={{ padding: '0 4px' }}
                                    >
                                        Regime de trabalho
                                    </InputLabel>

                                    <Select
                                        label="Regime de trabalho"
                                        native
                                        onChange={this.onChange}
                                        value={String(veiculo.regimetrabalho ?? AREGIME_TRABALHO_NENHUM)}
                                        inputProps={{
                                            id: 'outlined-age-native-simple',
                                            name: 'regimetrabalho'
                                        }}
                                    >
                                        <option
                                            key={AREGIME_TRABALHO_NENHUM}
                                            value={AREGIME_TRABALHO_NENHUM}
                                        >
                                            {"Nenhum"}
                                        </option>

                                        <option
                                            key={AREGIME_TRABALHO_SEVERO}
                                            value={AREGIME_TRABALHO_SEVERO}
                                        >
                                            {"Severo"}
                                        </option>

                                        <option
                                            key={AREGIME_TRABALHO_MISTO}
                                            value={AREGIME_TRABALHO_MISTO}
                                        >
                                            {"Misto"}
                                        </option>

                                        <option
                                            key={AREGIME_TRABALHO_RODOVIARIO}
                                            value={AREGIME_TRABALHO_RODOVIARIO}
                                        >
                                            {"Rodoviário"}
                                        </option>
                                    </Select>
                                </FormControl>
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                alignItems="center"
                                style={{ gap: 12 }}
                            >
                                <FormControlLabel
                                    label={'Veículo próprio'}
                                    control={
                                        <Checkbox
                                            checked={(veiculo.veiculoproprio === ASIM)}
                                            name="veiculoproprio"
                                            onChange={this.onChange}
                                            color="primary"
                                            disabled={isView}
                                        />
                                    }
                                />

                                <FormControlLabel
                                    label={'Figura no mapa de veículos'}
                                    control={
                                        <Checkbox
                                            checked={(veiculo.figuranomapa === ASIM)}
                                            name="figuranomapa"
                                            onChange={this.onChange}
                                            color="primary"
                                            disabled={isView}
                                        />
                                    }

                                />

                                {veiculo.veiculoproprio !== ASIM && (
                                    <FormControlLabel
                                        label={'Abastece veículo'}
                                        control={
                                            <Checkbox
                                                checked={(veiculo.abasteceveiculo === ASIM)}
                                                name="abasteceveiculo"
                                                onChange={this.onChange}
                                                color="primary"
                                                disabled={isView}
                                            />
                                        }
                                    />
                                )}
                            </Box>

                            <br />

                            <fieldset
                                fullWidth
                                style={{
                                    padding: 22,
                                    borderRadius: 5,
                                    border: '1px solid #ccc'
                                }}
                            >
                                <legend
                                    style={{
                                        padding: '0 10px',
                                        fontFamily: 'Calibri, sans-serif',
                                        fontWeight: 'bold',
                                        color: '#808080'
                                    }}
                                >
                                    Dados aquisição
                                </legend>

                                <Box
                                    display="flex"
                                    flexWrap="wrap"
                                    alignItems="center"
                                    style={{ gap: 12 }}
                                >
                                    <TextField
                                        label="Data"
                                        name="datacompraveiculo"
                                        onChange={this.onChange}
                                        type="date"
                                        value={getDateInputValue(veiculo.datacompraveiculo)}
                                        variant="outlined"
                                        disabled={isView}
                                        InputLabelProps={{
                                            shrink: true,
                                            required: false
                                        }}
                                        style={{
                                            flex: '0 1 180px',
                                            minWidth: 160
                                        }}
                                    />

                                    <FormControlLabel
                                        label={'Veículo usado'}
                                        control={
                                            <Checkbox
                                                checked={(veiculo.veiculousadoaquisicao === ASIM)}
                                                name="veiculousadoaquisicao"
                                                onChange={this.onChange}
                                                color="primary"
                                                disabled={isView}
                                            />
                                        }
                                    />
                                </Box>

                                <br />

                                <Box
                                    display="flex"
                                    flexWrap="wrap"
                                    style={{ gap: 12 }}
                                >
                                    <TextField
                                        label="Valor"
                                        name="valoraquisicao"
                                        value={getCurrencyInputValue(veiculo.valoraquisicao)}
                                        variant="outlined"
                                        onChange={this.handleChangeValorMonetario}
                                        disabled={isView}
                                        type="text"
                                        style={{
                                            flex: 1,
                                            minWidth: 150
                                        }}
                                    />

                                    <TextField
                                        label="Número NF"
                                        name="nronf"
                                        value={getInputValue(veiculo.nronf)}
                                        variant="outlined"
                                        disabled={isView}
                                        type="number"
                                        style={{
                                            flex: 1,
                                            minWidth: 150
                                        }}
                                        inputProps={{ min: 1 }}
                                        onChange={this.handlePositiveNumberChange}
                                    />
                                </Box>

                                <br />

                                <Box
                                    display="flex"
                                    flexWrap="wrap"
                                >
                                    <FormControl fullWidth>
                                        <ComboPadrao
                                            name={'codfornecaquisicao'}
                                            label={'Fornecedor aquisição'}
                                            value={veiculo.codfornecaquisicao}
                                            onChange={this.onChange}
                                            fieldId={'codfornecedor'}
                                            listItems={fornecedoresgeral}
                                            fieldDescription={'fantasia'}
                                        />
                                    </FormControl>
                                </Box>
                            </fieldset>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                            >
                                <FormControl
                                    variant="outlined"
                                    disabled={isView}
                                    fullWidth
                                >
                                    <ComboPadrao
                                        name={'codmotorista'}
                                        label={'Motorista padrão'}
                                        value={veiculo.codmotorista}
                                        onChange={this.onChange}
                                        fieldId={'codfornecedor'}
                                        listItems={motoristas}
                                        fieldDescription={'fantasia'}
                                    />
                                </FormControl>
                            </Box>

                            <br />

                            <Box>
                                <Typography
                                    color="textSecondary"
                                    component="p"
                                    variant="body2"
                                >
                                    Descritivo
                                </Typography>

                                <FormGroup>
                                    <textarea
                                        id="descritivo"
                                        name="descritivo"
                                        onChange={this.onChange}
                                        value={veiculo.descritivo || ''}
                                        disabled={isView}
                                        fullWidth
                                        style={{
                                            height: 80,
                                            padding: 8,
                                            border: '1px solid #ccc',
                                            borderRadius: 4,
                                            fontFamily: 'Calibri, sans-serif'
                                        }}
                                    />
                                </FormGroup>
                            </Box>

                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {/* ABA OPCIONAIS */}
                {activeTab === 3 &&
                    <TabContainer>
                        <CardContent>
                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                Veículo {veiculo.codveiculo}
                            </Typography>

                            <br />

                            <FormLabel
                                component="legend"
                                disabled={isView}
                                style={{
                                    textAlign: 'center',
                                    backgroundColor: '#e0e0e0',
                                    padding: 3
                                }}
                            >
                                Opcionais de veículo
                            </FormLabel>

                            <TableContainer
                                component={Paper}
                                fullWidth
                                style={{ overflowX: 'auto' }}
                            >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Descrição</TableCell>

                                            <TableCell align="center">Inativo</TableCell>

                                            <TableCell align="center">Ações</TableCell>

                                            <TableCell align="center">
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        disabled={isView}
                                                        onClick={this.handleOpenModalOpcionais}
                                                        style={{
                                                            color: 'black',
                                                            padding: '4px 12px'
                                                        }}
                                                    >
                                                        Inserir
                                                    </Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {opcionaisveiculo.map((opc, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="center">{opc.codopcionalveiculo}</TableCell>

                                                <TableCell align="center">{opc.descopcionalveiculo}</TableCell>

                                                <TableCell align="center">
                                                    {opc.inativoopc === ASIM ? 'Sim' : 'Não'}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Tooltip title="Remover">
                                                        <DeleteForeverOutlinedIcon
                                                            onMouseEnter={this.handleDeleteIconMouseEnter}
                                                            onMouseLeave={this.handleIconMouseLeave}
                                                            onClick={() => this.handleOpenRemoveOpcional(
                                                                opc.codopcionalveiculo,
                                                                opc.descopcionalveiculo
                                                            )}
                                                            style={actionIcon}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {/* ABA SEGURO */}
                {activeTab === 4 &&
                    <TabContainer>
                        <CardContent>
                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                Veículo {veiculo.codveiculo}
                            </Typography>

                            <br />

                            <Box>
                                <FormControl fullWidth>
                                    <ComboPadrao
                                        name={'codseguradora'}
                                        label={'Seguradora'}
                                        value={veiculo.codseguradora}
                                        onChange={this.onChange}
                                        fieldId={'codfornecedor'}
                                        listItems={fornecedoresgeral}
                                        fieldDescription={'fantasia'}
                                    />
                                </FormControl>
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Número apólice"
                                    name="apoliceseguro"
                                    value={veiculo.apoliceseguro || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />

                                <TextField
                                    label="Avisar dias antes do vencimento"
                                    name="avisovencsegurodias"
                                    value={getInputValue(veiculo.avisovencsegurodias)}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    onChange={this.handlePositiveNumberChange}
                                    style={{
                                        flex: '0 1 250px',
                                        minWidth: 250
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Início vigência"
                                    name="iniciovigenciaseguro"
                                    onChange={this.onChange}
                                    type="date"
                                    variant="outlined"
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    value={getDateInputValue(veiculo.iniciovigenciaseguro)}
                                    InputLabelProps={{
                                        shrink: true,
                                        required: false
                                    }}
                                    style={{
                                        flex: 1,
                                        minWidth: 150
                                    }}
                                />

                                <TextField
                                    label="Fim vigência"
                                    name="fimvigenciaseguro"
                                    onChange={this.onChange}
                                    type="date"
                                    variant="outlined"
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    value={getDateInputValue(veiculo.fimvigenciaseguro)}
                                    InputLabelProps={{
                                        shrink: true,
                                        required: false
                                    }}
                                    style={{
                                        flex: 1,
                                        minWidth: 150
                                    }}
                                />
                            </Box>

                            <br />

                            <fieldset
                                fullWidth
                                style={{
                                    padding: 15,
                                    borderRadius: 5,
                                    border: '1px solid #ccc'
                                }}
                            >
                                <legend
                                    style={{
                                        padding: '0 10px',
                                        fontFamily: 'Calibri, sans-serif',
                                        fontWeight: 'bold',
                                        color: '#808080'
                                    }}
                                >
                                    Valores
                                </legend>

                                <Box
                                    display="flex"
                                    flexWrap="wrap"
                                    style={{ gap: 12 }}
                                >
                                    <TextField
                                        label="Franquia"
                                        name="franquiaseguro"
                                        value={getCurrencyInputValue(veiculo.franquiaseguro)}
                                        variant="outlined"
                                        onChange={this.handleChangeValorMonetario}
                                        disabled={isView}
                                        type="text"
                                        fullWidth
                                    />
                                </Box>

                                <br />

                                <Box
                                    display="flex"
                                    flexWrap="wrap"
                                    style={{ gap: 12 }}
                                >
                                    <TextField
                                        label="Danos corporais"
                                        name="danoscorpseguro"
                                        value={getCurrencyInputValue(veiculo.danoscorpseguro)}
                                        variant="outlined"
                                        onChange={this.handleChangeValorMonetario}
                                        disabled={isView}
                                        type="text"
                                        style={{
                                            flex: 1,
                                            minWidth: 120
                                        }}
                                    />

                                    <TextField
                                        label="Danos morais"
                                        name="danosmoraisseguro"
                                        value={getCurrencyInputValue(veiculo.danosmoraisseguro)}
                                        variant="outlined"
                                        onChange={this.handleChangeValorMonetario}
                                        disabled={isView}
                                        type="text"
                                        style={{
                                            flex: 1,
                                            minWidth: 120
                                        }}
                                    />

                                    <TextField
                                        label="Danos materiais"
                                        name="danosmatseguro"
                                        value={getCurrencyInputValue(veiculo.danosmatseguro)}
                                        variant="outlined"
                                        onChange={this.handleChangeValorMonetario}
                                        disabled={isView}
                                        type="text"
                                        style={{
                                            flex: 1,
                                            minWidth: 120
                                        }}
                                    />
                                </Box>
                            </fieldset>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                            >
                                <TextField
                                    label="Local cópia documento - TS"
                                    variant="outlined"
                                    value={veiculo.localdocsegts || ''}
                                    disabled
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Buscar arquivo">
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            cursor: isUploadDisabledSegTS ? 'default' : 'pointer'
                                                        }}
                                                    >
                                                        <FolderOpenIcon
                                                            onMouseEnter={(e) => this.handleUploadIconMouseEnter(e, isUploadDisabledSegTS)}
                                                            onMouseLeave={(e) => this.handleUploadIconMouseLeave(e, isUploadDisabledSegTS)}
                                                            style={{
                                                                ...actionIcon,
                                                                color: isUploadDisabledSegTS ? '#bdbdbd' : '#3f51b5',
                                                                cursor: isUploadDisabledSegTS ? 'default' : 'pointer'
                                                            }}
                                                        />

                                                        <input
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            onChange={this.handleFileTS}
                                                            disabled={isView || isUploadDisabledSegTS}
                                                            ref={this.inputFileTSRef}
                                                        />
                                                    </label>
                                                </Tooltip>

                                                <Tooltip title="Remover">
                                                    <DeleteForeverOutlinedIcon
                                                        onClick={this.handleOpenConfirmRemoveSeguroTS}
                                                        onMouseEnter={(e) => this.handleRemoveFileIconMouseEnter(e, isDeleteDisabledSegTS)}
                                                        onMouseLeave={(e) => this.handleRemoveFileIconMouseLeave(e, isDeleteDisabledSegTS)}
                                                        style={{
                                                            ...actionIcon,
                                                            color: isDeleteDisabledSegTS ? '#bdbdbd' : '#3f51b5',
                                                            cursor: isDeleteDisabledSegTS ? 'default' : 'pointer',
                                                            pointerEvents: isDeleteDisabledSegTS ? 'none' : 'auto'
                                                        }}
                                                    />
                                                </Tooltip>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                            >
                                <TextField
                                    label="Local cópia documento - rede interna"
                                    variant="outlined"
                                    value={veiculo.localdocsegredeint || ''}
                                    disabled
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Buscar arquivo">
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            cursor: isUploadDisabledSegRedeInterna ? 'default' : 'pointer'
                                                        }}
                                                    >
                                                        <FolderOpenIcon
                                                            onMouseEnter={(e) => this.handleUploadIconMouseEnter(e, isUploadDisabledSegRedeInterna)}
                                                            onMouseLeave={(e) => this.handleUploadIconMouseLeave(e, isUploadDisabledSegRedeInterna)}
                                                            style={{
                                                                ...actionIcon,
                                                                color: isUploadDisabledSegRedeInterna ? '#bdbdbd' : '#3f51b5',
                                                                cursor: isUploadDisabledSegRedeInterna ? 'default' : 'pointer'
                                                            }}
                                                        />

                                                        <input
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            onChange={this.handleFileRedeInterna}
                                                            disabled={isView || isUploadDisabledSegRedeInterna}
                                                            ref={this.inputFileRedeInternaRef}
                                                        />
                                                    </label>
                                                </Tooltip>

                                                <Tooltip title="Remover">
                                                    <DeleteForeverOutlinedIcon
                                                        onClick={this.handleOpenConfirmRemoveSeguroRedeInterna}
                                                        onMouseEnter={(e) => this.handleRemoveFileIconMouseEnter(e, isDeleteDisabledSegRedeInterna)}
                                                        onMouseLeave={(e) => this.handleRemoveFileIconMouseLeave(e, isDeleteDisabledSegRedeInterna)}
                                                        style={{
                                                            ...actionIcon,
                                                            color: isDeleteDisabledSegRedeInterna ? '#bdbdbd' : '#3f51b5',
                                                            cursor: isDeleteDisabledRedeInterna ? 'default' : 'pointer',
                                                            pointerEvents: isDeleteDisabledSegRedeInterna ? 'none' : 'auto'
                                                        }}
                                                    />
                                                </Tooltip>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>

                            <br />

                            <Box>
                                <Typography
                                    color="textSecondary"
                                    component="p"
                                    variant="body2"
                                >
                                    Observação
                                </Typography>

                                <FormGroup>
                                    <textarea
                                        id="obsseguro"
                                        name="obsseguro"
                                        onChange={this.onChange}
                                        value={veiculo.obsseguro || ''}
                                        disabled={isView}
                                        fullWidth
                                        style={{
                                            height: 80,
                                            padding: 8,
                                            border: '1px solid #ccc',
                                            borderRadius: 4,
                                            fontFamily: 'Calibri, sans-serif'
                                        }}
                                    />
                                </FormGroup>
                            </Box>

                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {/* ABA DOCUMENTOS */}
                {
                    activeTab === 5 &&
                    <TabContainer>
                        <CardContent>
                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                Veículo {veiculo.codveiculo}
                            </Typography>

                            <br />

                            <FormLabel
                                component="legend"
                                disabled={isView}
                                style={{
                                    textAlign: 'center',
                                    backgroundColor: '#e0e0e0',
                                    padding: 3
                                }}
                            >
                                Documentos de veículo
                            </FormLabel>

                            <TableContainer
                                component={Paper}
                                fullWidth
                                style={{ overflowX: 'auto' }}
                            >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Descrição</TableCell>

                                            <TableCell align="center">Vencimento</TableCell>

                                            <TableCell align="center">Inativo</TableCell>

                                            <TableCell align="center">Ações</TableCell>

                                            <TableCell align="center">
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.handleOpenModalDocumentos}
                                                        disabled={isView}
                                                        style={{
                                                            color: 'black',
                                                            padding: '4px 12px'
                                                        }}
                                                    >
                                                        Inserir
                                                    </Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {documentosveiculo.map((doc, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="center">{doc.descricao}</TableCell>

                                                <TableCell align="center">{formatData(doc.vencimento)}</TableCell>

                                                <TableCell align="center">
                                                    {doc.inativodoc === ASIM ? 'Sim' : 'Não'}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Alterar">
                                                            <EditTwoToneIcon
                                                                onMouseEnter={this.handleIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                onClick={() => this.handleChangeDocumento(doc)}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlinedIcon
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                onClick={() => this.handleOpenDeleteDocumento(
                                                                    doc.chave,
                                                                    doc.descricao,
                                                                    doc.chave && !String(doc.chave).startsWith('tmp-doc-') ? doc.chave : index + 1
                                                                )}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {/* MODAL DOCUMENTOS */}
                <Dialog
                    open={openModalDocumentos}
                    onClose={this.handleCloseModalDocumentos}
                    maxWidth="sm"
                    fullWidth
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <DialogTitle>Documentos</DialogTitle>

                        <FormControlLabel
                            label={documento.inativodoc === ANAO ? 'Ativo' : 'Inativo'}
                            control={
                                <Switch
                                    checked={documento.inativodoc === ANAO}
                                    name="inativodoc"
                                    onChange={this.onChangeDocumento}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <DialogContent>
                        <Box>
                            <TextField
                                label="Veículo"
                                name="nroveiculo"
                                value={veiculo.nroveiculo || ''}
                                variant="outlined"
                                onChange={this.onChange}
                                disabled={isView}
                                inputProps={{ maxLength: 50 }}
                                InputProps={{
                                    readOnly: true,
                                    style: {
                                        color: 'rgba(0, 0, 0, 0.5)',
                                        backgroundColor: '#f5f5f5',
                                        pointerEvents: 'none'
                                    }
                                }}
                                style={{ backgroundColor: 'transparent' }}
                                fullWidth
                            />
                        </Box>

                        <br />

                        <Box>
                            <TextField
                                label="Descrição"
                                name="descricao"
                                value={documento.descricao || ''}
                                variant="outlined"
                                onChange={this.onChangeDocumento}
                                helperText={errors.descricao || ''}
                                error={!!errors.descricao}
                                disabled={isView}
                                inputProps={{ maxLength: 50 }}
                                fullWidth
                            />
                        </Box>

                        <br />

                        <Box
                            display="flex"
                            flexWrap="wrap"
                            style={{ gap: 12 }}
                        >
                            <TextField
                                inputProps={{ maxLength: 50 }}
                                label="Vencimento"
                                name="vencimento"
                                onChange={this.onChangeDocumento}
                                type="date"
                                value={getDateInputValue(documento.vencimento)}
                                variant="outlined"
                                disabled={isView}
                                InputLabelProps={{
                                    shrink: true,
                                    required: false
                                }}
                                style={{
                                    flex: 1,
                                    minWidth: 120
                                }}
                            />

                            <TextField
                                label="Avisar dias antes do vencimento"
                                name="avisodiasantecedencia"
                                value={getInputValue(documento.avisodiasantecedencia)}
                                variant="outlined"
                                disabled={isView}
                                type="number"
                                inputProps={{ min: 1 }}
                                onChange={this.handlePositiveNumberDocumentoChange}
                                style={{
                                    flex: 1,
                                    minWidth: 120
                                }}
                            />
                        </Box>

                        <br />

                        <Box>
                            <TextField
                                label="Local arquivo - TS"
                                variant="outlined"
                                value={documento.localdocts || ''}
                                disabled
                                fullWidth
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title="Buscar arquivo">
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        cursor: isUploadDisabledTS ? 'default' : 'pointer'
                                                    }}
                                                >
                                                    <FolderOpenIcon
                                                        onMouseEnter={(e) => this.handleUploadIconMouseEnter(e, isUploadDisabledTS)}
                                                        onMouseLeave={(e) => this.handleUploadIconMouseLeave(e, isUploadDisabledTS)}
                                                        style={{
                                                            ...actionIcon,
                                                            color: isUploadDisabledTS ? '#bdbdbd' : '#3f51b5',
                                                            cursor: isUploadDisabledTS ? 'default' : 'pointer'
                                                        }}
                                                    />

                                                    <input
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        onChange={this.handleFileDocumentoTS}
                                                        disabled={isView || isUploadDisabledTS}
                                                        ref={this.inputFileTSRef}
                                                    />
                                                </label>
                                            </Tooltip>

                                            <Tooltip title="Remover">
                                                <DeleteForeverOutlinedIcon
                                                    onClick={this.handleOpenConfirmRemoveDocumentoTS}
                                                    onMouseEnter={(e) => this.handleRemoveFileIconMouseEnter(e, isDeleteDisabledTS)}
                                                    onMouseLeave={(e) => this.handleRemoveFileIconMouseLeave(e, isDeleteDisabledTS)}
                                                    style={{
                                                        color: isDeleteDisabledTS ? '#bdbdbd' : '#3f51b5',
                                                        cursor: isDeleteDisabledTS ? 'default' : 'pointer',
                                                        pointerEvents: isDeleteDisabledTS ? 'none' : 'auto'
                                                    }}
                                                />
                                            </Tooltip>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>

                        <br />

                        <Box>
                            <TextField
                                label="Local arquivo - rede interna"
                                variant="outlined"
                                value={documento.localdocredeint || ''}
                                disabled
                                fullWidth
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title="Buscar arquivo">
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        cursor: isUploadDisabledRedeInterna ? 'default' : 'pointer'
                                                    }}
                                                >
                                                    <FolderOpenIcon
                                                        onMouseEnter={(e) => this.handleUploadIconMouseEnter(e, isUploadDisabledRedeInterna)}
                                                        onMouseLeave={(e) => this.handleUploadIconMouseLeave(e, isUploadDisabledRedeInterna)}
                                                        style={{
                                                            ...actionIcon,
                                                            color: isUploadDisabledRedeInterna ? '#bdbdbd' : '#3f51b5',
                                                            cursor: isUploadDisabledRedeInterna ? 'default' : 'pointer'
                                                        }}
                                                    />

                                                    <input
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        onChange={this.handleFileDocumentoRedeInterna}
                                                        disabled={isView || isUploadDisabledRedeInterna}
                                                        ref={this.inputFileRedeInternaRef}
                                                    />
                                                </label>
                                            </Tooltip>

                                            <Tooltip title="Remover">
                                                <DeleteForeverOutlinedIcon
                                                    onClick={this.handleOpenConfirmRemoveDocumentoRedeInterna}
                                                    onMouseEnter={(e) => this.handleRemoveFileIconMouseEnter(e, isDeleteDisabledRedeInterna)}
                                                    onMouseLeave={(e) => this.handleRemoveFileIconMouseLeave(e, isDeleteDisabledRedeInterna)}
                                                    style={{
                                                        color: isDeleteDisabledRedeInterna ? '#bdbdbd' : '#3f51b5',
                                                        cursor: isDeleteDisabledRedeInterna ? 'default' : 'pointer',
                                                        pointerEvents: isDeleteDisabledRedeInterna ? 'none' : 'auto'
                                                    }}
                                                />
                                            </Tooltip>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>

                        <br />

                        <Box>
                            <Typography
                                color="textSecondary"
                                component="p"
                                variant="body2"
                            >
                                Descritivo
                            </Typography>

                            <FormGroup>
                                <textarea
                                    id="descritivodoc"
                                    name="descritivodoc"
                                    onChange={this.onChangeDocumento}
                                    value={documento.descritivodoc}
                                    disabled={isView}
                                    fullWidth
                                    style={{
                                        height: 80,
                                        padding: 8,
                                        border: '1px solid #ccc',
                                        borderRadius: 4,
                                        fontFamily: 'Calibri, sans-serif'
                                    }}
                                />
                            </FormGroup>
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={this.handleCloseModalDocumentos}
                            color="secondary"
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={this.onClickSaveDocumento}
                            color="primary"
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* MODAL OPCIONAIS */}
                <Dialog
                    open={openModalOpcionais}
                    onClose={this.handleCloseModalOpcionais}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Opcionais de veículo</DialogTitle>

                    <DialogContent>
                        <Box>
                            <FormControl fullWidth>
                                <ComboPadrao
                                    name="codopcionalveiculo"
                                    label="Opcional"
                                    value={opcional.codopcionalveiculo}
                                    onChange={this.onChangeOpcional}
                                    fieldId="codopcionalveiculo"
                                    listItems={opcionais}
                                    fieldDescription="descopcionalveiculo"
                                />
                            </FormControl>
                        </Box>
                    </DialogContent>

                    <DialogActions style={{ justifyContent: 'space-between' }}>
                        <Box style={iconGroup}>
                            <Tooltip title="Cadastrar">
                                <PostAddIcon
                                    onClick={this.handleOpenModalTwo}
                                    onMouseEnter={this.handleIconMouseEnter}
                                    onMouseLeave={this.handleIconMouseLeave}
                                    style={actionIcon}
                                />
                            </Tooltip>

                            <Tooltip title="Alterar">
                                <EditTwoToneIcon
                                    onClick={() => this.handleOpenModalOne(false)}
                                    onMouseEnter={this.handleIconMouseEnter}
                                    onMouseLeave={this.handleIconMouseLeave}
                                    style={actionIcon}
                                />
                            </Tooltip>

                            <Tooltip title="Visualizar">
                                <VisibilityOutlinedIcon
                                    onClick={() => this.handleOpenModalOne(true)}
                                    onMouseEnter={this.handleIconMouseEnter}
                                    onMouseLeave={this.handleIconMouseLeave}
                                    style={actionIcon}
                                />
                            </Tooltip>

                            <Tooltip title="Excluir">
                                <DeleteForeverOutlinedIcon
                                    onClick={this.handleOpenDeleteOpcional}
                                    onMouseEnter={this.handleDeleteIconMouseEnter}
                                    onMouseLeave={this.handleIconMouseLeave}
                                    style={actionIcon}
                                />
                            </Tooltip>
                        </Box>

                        <Box>
                            <Button
                                onClick={this.handleInsertOpcional}
                                color="primary"
                            >
                                Selecionar
                            </Button>

                            <Button
                                onClick={this.handleCloseModalOpcionais}
                                color="default"
                            >
                                Fechar
                            </Button>
                        </Box>
                    </DialogActions>
                </Dialog>

                {/* MODAL EDIÇÃO/VISUALIZAÇÃO OPCIONAIS */}
                <Dialog
                    open={openModalOne}
                    onClose={this.handleCloseModalOne}
                    maxWidth="sm"
                    fullWidth
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <DialogTitle>Opcional de veículo</DialogTitle>

                        <FormControlLabel
                            label={opcional.inativoopc === ANAO ? 'Ativo' : 'Inativo'}
                            control={
                                <Switch
                                    checked={opcional.inativoopc === ANAO}
                                    name="inativoopc"
                                    onChange={this.onChangeOpcional}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <DialogContent>
                        <Box
                            display="flex"
                            flexWrap="wrap"
                            style={{ gap: 12 }}
                        >
                            <TextField
                                label="Código"
                                name="codopcionalveiculo"
                                value={opcional.codopcionalveiculo || ''}
                                variant="outlined"
                                onChange={this.onChangeOpcional}
                                disabled={isView}
                                InputProps={{
                                    readOnly: true,
                                    style: {
                                        color: 'rgba(0, 0, 0, 0.5)',
                                        backgroundColor: '#f5f5f5',
                                        pointerEvents: 'none'
                                    }
                                }}
                                style={{
                                    flex: '0 1 120px',
                                    minWidth: 120,
                                    backgroundColor: 'transparent'
                                }}
                            />

                            <TextField
                                label="Descrição"
                                name="descopcionalveiculo"
                                value={opcional.descopcionalveiculo || ''}
                                variant="outlined"
                                onChange={this.onChangeOpcional}
                                error={!!errors.descopcionalveiculo}
                                helperText={errors.descopcionalveiculo || ''}
                                disabled={isView}
                                inputProps={{ maxLength: 50 }}
                                style={{
                                    flex: 1,
                                    minWidth: 180
                                }}
                            />
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={this.handleCloseModalOne}
                            color="default"
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={this.onClickSaveOpcional}
                            color="primary"
                            disabled={isView}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* MODAL CADASTRO OPCIONAIS */}
                <Dialog
                    open={openModalTwo}
                    onClose={this.handleCloseModalTwo}
                    maxWidth="sm"
                    fullWidth
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <DialogTitle>Opcional de veículo</DialogTitle>

                        <FormControlLabel
                            label={opcional.inativoopc === ANAO ? 'Ativo' : 'Inativo'}
                            control={
                                <Switch
                                    checked={opcional.inativoopc === ANAO}
                                    name="inativoopc"
                                    onChange={this.onChangeOpcional}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <DialogContent>
                        <TextField
                            label="Descrição"
                            name="descopcionalveiculo"
                            value={opcional.descopcionalveiculo || ''}
                            variant="outlined"
                            onChange={this.onChangeOpcional}
                            error={!!errors.descopcionalveiculo}
                            helperText={errors.descopcionalveiculo || ''}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            fullWidth
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={this.handleCloseModalTwo}
                            color="default"
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={this.onClickSaveOpcional}
                            color="primary"
                            disabled={isView}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                <DeleteConfirmationModal
                    open={openConfirmDeleteDocumento}
                    handleClose={this.handleCloseDeleteDocumento}
                    itemId={documentoASerExcluido}
                    message={`Confirma exclusão do documento de veículo ${documentoDescASerExcluido || ''} [${documentoChaveASerExcluida}]?`}
                    handleDelete={this.handleConfirmDeleteDocumento}
                />

                <DeleteConfirmationModal
                    open={openConfirmDeleteOpcional}
                    handleClose={this.handleCloseDeleteOpcional}
                    itemId={opcionalASerExcluido}
                    message={`Confirma exclusão do opcional de veículo ${opcionalDescASerExcluido || ''} [${opcionalASerExcluido}]?`}
                    handleDelete={this.handleConfirmDeleteOpcional}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveOpcional}
                    handleClose={this.handleCloseRemoveOpcional}
                    itemId={opcionalASerRemovido}
                    message={`Confirma remoção do opcional de veículo ${opcionalDescASerRemovido || ''} [${opcionalASerRemovido}] da grid?`}
                    handleDelete={this.handleConfirmRemoveOpcional}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveSeguroTS}
                    handleClose={this.handleCloseConfirmRemoveSeguroTS}
                    itemId=""
                    message={"Confirma remoção do arquivo TS?"}
                    handleDelete={this.handleConfirmRemoveSeguroTS}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveSeguroRedeInterna}
                    handleClose={this.handleCloseConfirmRemoveSeguroRedeInterna}
                    itemId=""
                    message={"Confirma remoção do arquivo de rede interna?"}
                    handleDelete={this.handleConfirmRemoveSeguroRedeInterna}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveDocumentoTS}
                    handleClose={this.handleCloseConfirmRemoveDocumentoTS}
                    itemId=""
                    message={"Confirma remoção do arquivo TS?"}
                    handleDelete={this.handleConfirmRemoveDocumentoTS}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveDocumentoRedeInterna}
                    handleClose={this.handleCloseConfirmRemoveDocumentoRedeInterna}
                    itemId=""
                    message={"Confirma remoção do arquivo de rede interna?"}
                    handleDelete={this.handleConfirmRemoveDocumentoRedeInterna}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div >
        );
    }
};

export default VeiculoForm;